import { create } from 'zustand';
import type { TGroupItemFrontend } from '@/types/common.ts';

type TConnectorData = {
	idn?: string;
	client_secret?: string;
	external_id?: string;
};

type NotificationPayload = {
	data: TGroupItemFrontend;
	operation: NotificationOperation;
};
interface IAppStoreState {
	connectorData: TConnectorData;
	notification: NotificationPayload | null;
	resetState: () => void;
	setNotification: (payload: NotificationPayload | null) => void;
	setConnectorData: (connector: Partial<TConnectorData>) => void;
}

const createInitialState = () => ({
	connectorData: {
		idn: undefined,
		client_secret: undefined,
		external_id: undefined
	},
	notification: null
});

const useAppStore = create<IAppStoreState>()((set) => ({
	...createInitialState(),
	resetState: () => set(createInitialState()),
	setNotification: (payload: NotificationPayload | null) =>
		set({ notification: payload }),
	setConnectorData: (data) =>
		set((state) => ({ connectorData: { ...state.connectorData, ...data } }))
}));

export enum NotificationOperation {
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
	REMOVE = 'REMOVE',
	REMOVE_FROM_CANVAS = 'REMOVE_FROM_CANVAS',
	CLONE = 'CLONE',
	REVERT_TO_ORIGINAL = 'REVERT_TO_ORIGINAL'
}

export default useAppStore;
